<template>
  <div>
    <van-nav-bar title="兑换专区" left-text="" left-arrow @click-left="onClickLeft()" />
    <!-- <van-grid :border="false" :column-num="2" :gutter="9">
      <van-grid-item v-for="(item,idx) in goodList" v-bind:key="idx">
        <goodGrid :goodName="item.GoodsName" :id="item.ID" :imgUrl="item.GoodsImg"></goodGrid>

      </van-grid-item>
    </van-grid> -->
    <div class="aui-take-item">
      <div class="aui-flex" style="padding-bottom:5px;">
        <div class="aui-flex-box">
          <h3>我的阶段积点：{{currentcount}}积点</h3>
        </div>
        <div class="aui-arrow">
          <van-button plain hairline round type="danger" size="mini" @click="onConvertLog">兑换记录</van-button>
        </div>
      </div>
    </div>
    <div class="tips">
      *温馨提示：水电工程师可根据自己积点情况，随时自由组合兑换等价奖品！（图片仅供参考，具体以实物为准）
    </div>
    <div class="tips">
      *说明：所有积点在1月10日之前兑换完毕，过期作废。已兑换奖品将在每月月底进行统一快递，7个工作日内未收到请及时联系400-189-1892，如未联系将不补发。
    </div>
    <div style="margin-top:10px;" v-for="(item,idx) in prizeList" v-bind:key="idx">
      <van-cell-group inset style="margin-top:10px;">
        <van-card
        :price="item.ConvertNum+'积点'"
        currency=""
        :title="item.PrizeName"
        :desc="item.PrizeDesc"
        >
        <template #bottom v-if="item.PrizeName=='天力冲锋衣'">
          <van-radio-group v-model="size" direction="horizontal" @change="selectSize">
            <van-radio name="L">L</van-radio>
            <van-radio name="XL">XL</van-radio>
            <van-radio name="2XL">2XL</van-radio>
            <van-radio name="3XL">3XL</van-radio>
          </van-radio-group>
        </template>
        <template #footer>
          <van-button round type="danger" size="mini" @click="convert(item.ID,item.PrizeName)">立即兑换</van-button>
        </template>
        <template #thumb>
          <img v-if="item.PrizeName=='天力模头2套件'" src="../../assets/convert/天力模头2.jpg" style="height:88px;width:88px;" alt="">
          <img v-if="item.PrizeName=='天力保温杯'" src="../../assets/convert/天力保温杯2.jpg" style="height:88px;width:88px;" alt="">
          <img v-if="item.PrizeName=='天力热熔机'" src="../../assets/convert/天力热熔机2.jpg" style="height:88px;width:88px;" alt="">
          <img v-if="item.PrizeName=='天力冲锋衣'" src="../../assets/convert/天力冲锋衣2.jpg" style="height:88px;width:88px;" alt="">
          <img v-if="item.PrizeName=='东成电锤(FF03-28)'" src="../../assets/convert/东成电锤2.jpg" style="height:88px;width:88px;" alt="">
        </template>
        </van-card>
      </van-cell-group>
    </div>

  </div>
</template>

<script>
import { Button, Card, CellGroup, NavBar, Dialog, RadioGroup, Radio } from "vant";
export default {
  data() {
    return {
      fileUrl: this.$file.url,
      prizeList: [],
      currentcount: 0,
      num: 0,
      size: ""
    };
  },
  props: {},
  computed: {
    isLogined() {
      return this.$store.state.isLogin;
    },
  },
  methods: {
    GetData() {
      var that = this;
      this.$http.get("Prizes/GetPrizesList", {
        params: {
          pageIndex: 1,
        },
      }).then((res) => {
        that.prizeList = res.data.ListData;
        that.$toast.clear();
      });
    },
    GetActivityPeriod2022() {
      var that = this;
      that.$http.get("Prizes/GetActivityPeriod2022").then((res) => {
        that.currentcount = res.data.Data;
      });
    },
    GetConvertAddr() {
      var that = this;
      that.$http.get("Prizes/GetConvertAddr").then((res) => {
        that.num = res.data.Data.num;
      });
    },
    // 兑换 
    convert(id,name) {
      var that = this;
      if(name=="天力冲锋衣"&&that.size==""){
        return that.$toast.fail("请先选择尺码");
      }
      Dialog.confirm({
        title: "兑换",
        message:
          "是否确认兑换该奖品，兑换成功后无法更换?",
      })
      .then(() => {
        // on confirm
        that.$http.get("Prizes/Convert2022", {
          params: {
            prizeId:id,
            size:that.size
          },
        })
        .then((res) => {
          if (res.data == "success") {
            Dialog.alert({
                message: '您的奖品兑换成功！请填写收货地址，填写后请耐心等待奖品配送。',
                theme: 'round-button',
              }).then(() => {
                // on close
                this.$router.push({
                  name: "ConvertAddrsEdit",
                  params: {},
              });
            });              
          } else {
            that.$toast(res.data);
          }
        });
      })
      .catch(() => {
        // on cancel
      });
    },
    onConvertLog() {
      if (!this.isLogined) {
        return this.$toast.fail("您还未登录");
      }
      this.$router.push({
        name: "ConvertList",
        params: {},
      });
    },
    selectSize(s) {
      this.size=s;
    },
    onClickLeft() {
      this.$router.back(-1);
    },
  },
  mounted() {
    this.GetData();
    this.GetActivityPeriod2022();
    this.GetConvertAddr();
  },
  components: {
    [NavBar.name]: NavBar,
    [Card.name]: Card,
    [Button.name]: Button,
    [CellGroup.name]: CellGroup,
    [Dialog.name]: Dialog,
    [RadioGroup.name]: RadioGroup,
    [Radio.name]: Radio,
  },
};

</script>

<style scoped>
.aui-take-item {
  background: #fff;
  border-radius: 5px;
  margin: 0.5rem;
}

.aui-flex {
  display: flex;
  -webkit-box-align: center;
  align-items: center;
  padding: 5px;
  position: relative;
}

.aui-flex-box {
  -webkit-box-flex: 1;
  flex: 1;
  min-width: 0;
  font-size: 14px;
  color: #333;
  text-align: left;
}
.tips {
  font-size: 15px;
  color: red;
  margin-left: 10px;
  margin-right: 10px;
  margin-top: 5px;
}
</style>